'use strict';

var FlightKpiRibbonAggregationFactory = function FlightKpiRibbonAggregationFactory(DataAggregationFactory, flightKpiRibbonAggregationService) {
  function KpiRibbonAggregation() {
    DataAggregationFactory.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'kpi-ribbon');
    this.aggregationConfig = require('../../../config/flightKpiRibbonAggregationConfig.json');
  }
  KpiRibbonAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  KpiRibbonAggregation.constructor = KpiRibbonAggregation;
  KpiRibbonAggregation.prototype.aggregate = function (data) {
    // simple aggregations to compute
    var aggregations = {
      resHoldTotalCurrent: undefined,
      resHoldTotalExpected: undefined,
      resHoldTotalCurrentReference: undefined,
      resHoldTotalFinalReference: undefined,
      revenueCurrent: undefined,
      revenueExpected: undefined,
      revenueCurrentReference: undefined,
      revenueFinalReference: undefined,
      resHoldTotalDeparture: undefined,
      thisYearFinalBookings: undefined,
      thisYearFinalRevenue: undefined,
      // ASD
      availableSeatDistanceCurrent: undefined,
      availableSeatDistanceCurrentReference: undefined,
      availableSeatDistanceFinalReference: undefined,
      // RPD
      revenuePaxDistanceCurrent: undefined,
      revenuePaxDistanceCurrentReference: undefined,
      revenuePaxDistanceFinalReference: undefined,
      revenuePaxDistanceExpected: undefined
    };
    return flightKpiRibbonAggregationService.aggregate(data, aggregations, this.aggregationConfig);
  };
  return KpiRibbonAggregation;
};
FlightKpiRibbonAggregationFactory.$inject = ['DataAggregationFactory', 'FlightKpiRibbonAggregationService'];
module.exports = FlightKpiRibbonAggregationFactory;